import { useNotification } from 'admin';
import { isFieldErrorResponse, useApiTradeV1SiteMaterialsCreate } from 'api';
import { UseFormReturn } from 'form';

import { FormValues } from '~/site-materials/components/NewCompanySiteMaterialForm/NewCompanySiteMaterialForm';

export const useCreateSiteMaterial = (form: UseFormReturn<FormValues>) => {
  const { open } = useNotification();
  return useApiTradeV1SiteMaterialsCreate({
    mutation: {
      onError(error) {
        if (isFieldErrorResponse(error)) {
          Object.keys(error.response?.data).forEach((field) => {
            form.setError(field as keyof FormValues, { message: error.response.data[field] });
          });
          if (error.response?.data.non_field_errors) {
            open?.({
              description: error?.response?.data.non_field_errors[0],
              message: 'Error creating material',
              type: 'error',
            });
          }
          if (error.response?.data.detail) {
            open?.({
              description: error.response?.data.detail,
              message: 'Error creating material',
              type: 'error',
            });
          }
        }
      },
      onSuccess() {
        open?.({
          description: 'Material created',
          message: 'Material created',
          type: 'success',
        });
      },
    },
  });
};
